import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function About() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen pt-24 pb-14">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "51暗网吃瓜",
            url: "http://hnwmjg.cn/",
            description: "国内领先的娱乐八卦资讯聚合平台",
            contactPoint: {
              "@type": "ContactPoint",
              email: "hello@hnwmjg.cn",
              contactType: "customer service",
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "首页",
                item: "http://hnwmjg.cn/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "关于我们",
              },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "51暗网吃瓜是什么？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "51暗网吃瓜是国内领先的娱乐八卦资讯聚合平台，提供每日大赛、网红爆料、匿名黑料等最新娱乐资讯。",
                },
              },
              {
                "@type": "Question",
                name: "如何下载51暗网吃瓜APP？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "您可以在官网首页下载区域找到iOS版和安卓版的下载入口，点击对应按钮即可下载安装。",
                },
              },
              {
                "@type": "Question",
                name: "51暗网吃瓜的内容来源是什么？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "本站内容来源于互联网公开信息及用户投稿，我们汇聚全网热门爆料，为吃瓜群众提供一站式资讯服务。",
                },
              },
            ],
          }),
        }}
      />
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <nav className="flex items-center gap-2 text-sm text-foreground-400 mb-8">
          <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
            {t("breadcrumb.home")}
          </Link>
          <span>/</span>
          <span className="text-foreground-700">{t("about.title")}</span>
        </nav>

        <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-10">
          {t("about.title")}
        </h1>

        <section className="mb-12">
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-4 flex items-center gap-2">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-information-line text-primary-500 text-lg"></i>
            </div>
            {t("about.intro")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            {t("about.intro.content")}
          </p>
        </section>

        <section className="mb-12">
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-4 flex items-center gap-2">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-thumb-up-line text-primary-500 text-lg"></i>
            </div>
            {t("about.reputation")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            {t("about.reputation.content")}
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
            {[
              { value: "500万+", label: "月活跃用户" },
              { value: "10万+", label: "累计爆料" },
              { value: "99.7%", label: "用户满意度" },
              { value: "24小时", label: "全天候更新" },
            ].map((stat) => (
              <div key={stat.label} className="text-center p-4 rounded-lg bg-background-100">
                <p className="text-xl md:text-2xl font-bold text-accent-500 mb-1">{stat.value}</p>
                <p className="text-xs text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mb-12">
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-4 flex items-center gap-2">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-mail-line text-primary-500 text-lg"></i>
            </div>
            {t("about.contact")}
          </h2>
          <div className="bg-background-100 rounded-lg p-6 md:p-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                  <i className="ri-mail-line text-primary-500 text-lg"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900 mb-1">{t("about.contact.email")}</p>
                  <p className="text-sm text-foreground-500">hello@hnwmjg.cn</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                  <i className="ri-wechat-line text-accent-500 text-lg"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900 mb-1">{t("about.contact.wechat")}</p>
                  <p className="text-sm text-foreground-500">51暗网吃瓜</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-200 flex-shrink-0">
                  <i className="ri-qq-line text-secondary-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900 mb-1">{t("about.contact.qq")}</p>
                  <p className="text-sm text-foreground-500">88888888</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100 rounded-lg p-6 md:p-8">
          <h2 className="text-lg font-heading font-semibold text-foreground-900 mb-3">
            免责声明
          </h2>
          <p className="text-sm text-foreground-500 leading-relaxed">
            本站所有内容均来源于互联网公开信息及用户投稿，仅供娱乐消遣之用，不构成任何形式的建议或承诺。
            51暗网吃瓜不对所发布内容的真实性、准确性和完整性做任何保证。如涉及版权或个人权益问题，
            请通过上述联系方式与我们取得联系，我们将在核实后第一时间处理。
          </p>
        </section>
      </div>
    </div>
  );
}